"use client";

import { TimeFrame } from "charts/src/types/chart";
import { useState } from "react";

import { ChartGridLayout } from "@/features/analysis/components/key-metrices-charts/components/ChartGridLayout";
import ChartTimeFrameButtonGroup from "@/features/analysis/components/key-metrices-charts/components/ChartTimeFrameButtonGroup";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

type Props = {
  lang: Lang;
  symbol: string;
};

export const KeyMetricesView = ({ lang, symbol }: Props) => {
  const { t } = getTranslations(lang);
  const [timeFrame, setTimeFrame] = useState<TimeFrame>("Q");
  return (
    <>
      <h2 className="mb-6 sm:mb-2">
        {t.analysis.overview.keyMetrices(symbol)}
      </h2>
      <div>
        <ChartTimeFrameButtonGroup
          lang={lang}
          type="overview"
          onButtonClick={(value) => setTimeFrame(value as TimeFrame)}
        />
        <ChartGridLayout
          symbol={symbol}
          lang={lang}
          timeframe={timeFrame}
          chartCategoryPath="overview"
          emptyHandlingPolicy="show-empty-view"
        />
      </div>
    </>
  );
};
